'use strict';
/* COMPONENT - c.06.01 - Shop map */

export default class ShopMap {

    constructor(element) {
        this.root = element;
        this.link = this.root.querySelector('.shop-map-link');
        if (this.link) {
            this.coords = this.link.getAttribute('data-coords');
        }
    }

    checkLocation() {
        if (this.link && this.coords) {
            navigator.geolocation.getCurrentPosition((position, err) => {
                this.long = position.coords.longitude;
                this.lat = position.coords.latitude;
                // change url to directions
                var url = `https://www.google.com/maps/dir/?api=1&origin=${this.lat},${this.long}&destination=${this.coords}`;
                this.link.setAttribute('href', url);
            }, (err) => {
                console.log(err);
            });
        }
    }
}
